import useSWR from 'swr'

export const useIndustries = () => useSWR('industries');
